<script>
  import ChangeStatus from './ChangeStatus.vue'
  import Service from '../../../../domain/leiloes/services/pregao'
  import {number_format as numberFormat} from '../../../../utils/helpers/phpjs'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'

  export default {
    name: 'u-keyboard',
    props: ['startShow'],
    data () {
      return {
        show: this.startShow,
        dblkeyLance: 0,
        processandoLance: false,
        processandoDelete: false
      }
    },
    created () {
      /* document.addEventListener('keyup', (pKey) => {
       console.log(pKey)
       }) */
    },
    computed: {
      Status () {
        return Status
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      toggleKeyboard () {
        this.show = !this.show
        this.$emit('toggle', this.show)
      },

      selecionarLote () {
        console.log('Selecionar Lote')
        let numero = prompt('Qual o número do lote?')
        if (parseInt(numero) < 0 || typeof numero === 'undefined' || numero === null) {
          return
        }
        this.mudarLoteEspecifico(numero)
      },
      mudarLoteEspecifico (numero) {
        console.log('Trocando lote para o anterior...')
        this.$refs.changeStatus.open('Mudando para Lote ' + numero)
        Service.mudarLote(this.$route.params.id, numero)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('mudarLote', {acao: 'trocar', lote: response.data.lote, pregao: response.data.pregao})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            console.log(Number(response.status))
            if (Number(response.status) === 401) {
              window.alert('Lote não encontrado')
              return
            }
            // window.alert('Erro ao mudar de lote. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },
      anterior () {
        console.log('Trocando lote para o anterior...')
        this.$refs.changeStatus.open('Mudando para Lote Anterior')
        Service.voltarLote(this.$route.params.id)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('mudarLote', {acao: 'voltar', lote: response.data.lote, pregao: response.data.pregao})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            console.log(Number(response.status))
            if (Number(response.status) === 401) {
              window.alert('Não há mais lotes para avançar')
              return
            }
            // window.alert('Erro ao mudar de lote. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },

      proximo () {
        console.log('Trocando lote para o próximo...')
        this.$refs.changeStatus.open('Mudando para Próximo Lote')
        Service.avancarLote(this.$route.params.id)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('mudarLote', {acao: 'avancar', lote: response.data.lote, pregao: response.data.pregao})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            if (Number(response.status) === 401) {
              window.alert('Não há mais lotes para avançar')
              return
            }
            // window.alert('Erro ao mudar de lote. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },

      deletarLance () {
        window.setTimeout(() => {
          this.processandoDelete = false
        }, 3000)

        if (this.processandoDelete) {
          return
        }

        this.processandoDelete = true
        console.log('Deletando último lance...')
        if (typeof this.$parent.lote.lances[0] === 'undefined') {
          window.alert('Nenhum lance para apagar')
          // this.processandoDelete = false
          return
        }
        let lance = this.$parent.lote.lances[0]
        this.$confirm.open('Tem certeza que deseja deletar o lance de ' + lance.arrematante.apelido + ' no valor de R$ ' + numberFormat(lance.valor, 2, ',', '.') + '?', {
          message: 'Deletar',
          color: 'btn-danger'
        }, 'Cancelar', null, (v) => {
          if (v === false) {
            this.processandoDelete = false
            return
          }
          console.log('Deletando lance ' + lance.id + '...')
          this.$refs.changeStatus.open('Deletando Lance')

          Service.deletarLance(lance.id)
            .then((response) => {
              this.processandoDelete = false
              this.$refs.changeStatus.close()
              this.$emit('deletarLance', lance)
            })
            .catch((response) => {
              this.processandoDelete = false
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
      },

      loteStatus (s, lote, noConfirm) {
        noConfirm = typeof noConfirm !== 'undefined' ? noConfirm : false
        if (typeof lote === 'undefined') {
          lote = this.$parent.lote.id
        }
        this.$confirm.open('Tem certeza que deseja alterar o status do lote para ' + Status.StatusTitle(s) + '?', 'Alterar Status para ' + Status.StatusTitle(s), 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          this.updateLoteStatus(s, lote)
        })
      },
      updateLoteStatus (s, lote) {
        console.log('Trocando status do lote para ' + s + '...')
        this.$refs.changeStatus.open('Alterando status do lote')
        Service.alteraStatusLote(this.$route.params.id, lote, s)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('statusLote', response.data.lote)
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            window.responseError(response)
            console.log(response)
          })
      },
      lanceManual (valor) {
        console.log('Efetuando lance manual...')
        this.$refs.changeStatus.open('Efetuando lance')
        if (typeof this.$parent.lote.lances !== 'undefined' && valor === 0) {
          console.log('aqui 2')
          if (typeof this.$parent.lote.lances[0] !== 'undefined') {
            console.log('aqui 3')
            if (this.$parent.lote.lances[0].arrematante.apelido !== 'PLATEIA') {
              console.log('aqui 4')
              this.$refs.changeStatus.open('Último lance com origem online, pressione rapidamente duas vezes a tecla + para cobrir o lance')
              console.log('Último lance com origem online, pressione rapidamente duas vezes a tecla + para cobrir o lance.')
              this.dblkeyLance++
              if (this.dblkeyLance === 1) {
                let self = this
                this.timerKeyLance = setTimeout(function () {
                  self.dblkeyLance = 0
                }, 500)
                return
              } else {
                clearTimeout(this.timerKeyLance)
                this.$refs.changeStatus.open('Efetuando lance')
                this.dblkeyLance = 0
              }
            }
          }
        }
        if (this.processandoLance) return

        this.processandoLance = true
        Service.lancePlateia(this.$route.params.id, this.$parent.lote.id, valor)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.focusMe()
            this.processandoLance = false
            // this.$emit('novoLance', response.data.lote, response.data.lance)
          })
          .catch((response) => {
            this.processandoLance = false
            this.$refs.changeStatus.close()
            window.responseError(response)
            console.log(response)
          })
      },
      doulheUma () {
        console.log('Alterando status do lote para Dou-lhe Uma...')
      },
      doulheDuas () {
        console.log('Alterando status do lote para Dou-lhe Duas...')
      },
      baixaOferta () {
        console.log('Alterando status do lote para Baixa Oferta...')
      },
      semLicitantes () {
        console.log('Alterando status do lote para Sem Licitantes...')
      },
      homologando () {
        console.log('Homologando...')
      },
      condicional () {
        console.log('Alterando status do lote para Condicional...')
      },
      vendido () {
        console.log('Alterando status do lote para Vendido...')
      },
      renovarTempo () {
        console.log('Renovando tempo do pregão/lote')
        Service.renovaTempoPregaoLote(this.$route.params.id, this.$parent.lote.id)
          .then((response) => {
            this.$emit('renovaTempo', response.data)
          })
          .catch((response) => {
            window.responseError(response)
            console.log(response)
          })
      },
      focusMe () {
        this.$refs.focusme.focus()
      }
    },
    components: {
      ChangeStatus
    }
  }
</script>

<template>
  <div>
    <a ref="focusme" style="width: 0; height: 0"></a>
    <a v-shortkey="['f6']" @shortkey="selecionarLote"></a>
    <change-status ref="changeStatus"></change-status>
    <div class="keyboard" :class="{khide: !show}">
      <a class="toggle" @click="toggleKeyboard"></a>
      <div class="buttons">
        <a class="control-anterior" v-shortkey="['arrowleft']" @shortkey="anterior"
           @click="anterior">Anterior <i>&larr;</i></a>
        <a class="control-proximo" v-shortkey="['arrowright']" @shortkey="proximo" @click="proximo">Próximo <i>
          &rarr;</i></a>
        <a class="control-deletar-lance" v-shortkey="['delete']"
           @shortkey="deletarLance" @click="deletarLance">Deletar Lance <i>Delete</i></a>
        <a class="control-aberto" v-shortkey="['1']" @shortkey="loteStatus(Status.STATUS_ABERTO_PARA_LANCES)"
           @click="loteStatus(Status.STATUS_ABERTO_PARA_LANCES)">Aberto <i>1</i></a>
        <a class="control-pregao" v-shortkey="['2']" @shortkey="loteStatus(Status.STATUS_EM_PREGAO)"
           @click="loteStatus(Status.STATUS_EM_PREGAO)">Em Pregão <i>2</i></a>
        <a class="control-incremento" v-shortkey="['+']" @shortkey="lanceManual(0)"
           @click="lanceManual(0)">Incremento <i>+</i></a>
        <a class="control-dolheuma" v-shortkey="['3']" @shortkey="loteStatus(Status.STATUS_DOULHE_UMA)"
           @click="loteStatus(Status.STATUS_DOULHE_UMA)">Dou-lhe Uma <i>3</i></a>
        <a class="control-doulheduas" v-shortkey="['4']" @shortkey="loteStatus(Status.STATUS_DOULHE_DUAS)"
           @click="loteStatus(Status.STATUS_DOULHE_DUAS)">Dou-lhe Duas <i>4</i></a>
        <a class="control-baixaoferta" v-shortkey="['0']" @shortkey="loteStatus(Status.STATUS_BAIXA_OFERTA)"
           @click="loteStatus(Status.STATUS_BAIXA_OFERTA)">Rejeitado <i>0</i></a>
        <a class="control-semlicitantes" v-shortkey="[',']" @shortkey="loteStatus(Status.STATUS_SEM_LICITANTES)"
           @click="loteStatus(Status.STATUS_SEM_LICITANTES)">Sem Licitantes <i>,</i></a>
        <a class="control-homologando" v-shortkey="['*']" @shortkey="loteStatus(Status.STATUS_HOMOLOGANDO)"
           @click="loteStatus(Status.STATUS_HOMOLOGANDO)">Homologando <i>*</i></a>
        <a class="control-condicional" v-shortkey="['9']" @shortkey="loteStatus(Status.STATUS_CONDICIONAL)"
           @click="loteStatus(Status.STATUS_CONDICIONAL)">Condicional <i>9</i></a>
        <a class="control-vendido" v-shortkey="['.']" @shortkey="loteStatus(Status.STATUS_VENDIDO)"
           @click="loteStatus(Status.STATUS_VENDIDO)">Vendido <i>.</i></a>
      </div>
      <div class="text-center no-select" v-shortkey="['t']" @shortkey="renovarTempo()">Aperte <strong
        class="label label-default box-shadow m-r-xs m-l-xs">T</strong> para renovar o tempo
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Keyboard.vue?6dbf1a12